import * as React from 'react'
import styled from "styled-components"
import { ColumnFlexBox } from '../../components/templates/Wrappers'
import colors from '../../globals/colors'
import { InvestmentsList } from '../../components/organisms/InvestmentsList'
import Project from '../../shared/Project'
import { NiceIntrestRate, NiceNumberWithCurrency } from '../../shared/UIFormatting'
import { lang } from '../../globals/Translations'
import { TranslatedTerms } from '../../globals/TranslatedTerms'
import CompletionChart, { IconSizes } from '../../components/molecules/CompletionChart'
import { getProjectStatus, ProjectStatus } from '../../shared/ProjectStatus'

const GeneralDefaultPaper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-color: ${colors.dark};
    color: ${colors.lightest}!important;
    padding: 16px;
    border-radius: 4px;
    position: relative;
    box-shadow: 0 0 16px rgba(0,0,0,.5);
    margin-top: -8px;
    margin-bottom: -8px;
    margin-left: -8px;
    margin-right: -8px;
    z-index: 1;
`


export const InvestmentDetailItem: React.FC<{ name?: string, value?: string }> = ({ value, name }) => (
    <ColumnFlexBox style={{ alignItems: 'center', marginTop: 10 }}>
        <span style={{ fontWeight: 400 }}>{value}</span>
        <span style={{ fontSize: 10, lineHeight: 1, fontWeight: 700 }}>{(name || '').toUpperCase()}</span>
    </ColumnFlexBox>
)

const isProjectComplete = (status: ProjectStatus) => {
    if (status === ProjectStatus.INVESTOR_RECIVING_INTREST) return true
    if (status === ProjectStatus.WAITING_FOR_START) return true
    if (status === ProjectStatus.PROJECT_COMPLETED) return true
    return false
}

export const InvestmentDetails: React.FC<{ project?: Project }> = ({ project }) => {
    const projectComplete = !!project && isProjectComplete(getProjectStatus(project))
    const targetFunding = project && project.finance.targetFunding || 1
    const currentFunding = project && (projectComplete ? targetFunding : project.finance.currentFunding) || 1
    const percent = Math.floor((currentFunding / targetFunding) * 100)

    return (
        <GeneralDefaultPaper>
            <div>
                <h4 style={{ color: colors.lightest }}>{lang(TranslatedTerms.A_GOOD_INVESTMENT)}</h4>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 30 }}>
                    {project && <CompletionChart iconSize={IconSizes.Large} percent={percent} />}
                </div>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gridRowGap: 10, marginTop: 20, marginBottom: 20 }}>
                <InvestmentDetailItem value={project && NiceNumberWithCurrency(currentFunding === 1 ? 0 : currentFunding)} name={lang(TranslatedTerms.CURRENT_FUNDING)} />
                <InvestmentDetailItem value={project && NiceNumberWithCurrency(targetFunding)} name={lang(TranslatedTerms.PROJECT_SIZE)} />
                <InvestmentDetailItem value={project && NiceIntrestRate(project.finance.interestRate, true)} name={lang(TranslatedTerms.INTEREST_RATE_PR_Y)} />
                <InvestmentDetailItem value={project && NiceNumberWithCurrency(project.finance.minimumInvestment)} name={lang(TranslatedTerms.MIN_INVESTMENT)} />
                <InvestmentDetailItem value={project && (project.finance.durationMin + " - " + project.finance.durationMax + " " + lang(TranslatedTerms.MTH).toLocaleLowerCase())}
                    name={lang(TranslatedTerms.DURATION)} />
                <InvestmentDetailItem value={project && NiceIntrestRate(project.finance.coveragePercentage)} name={lang(TranslatedTerms.COVER)} />
            </div>
            <InvestmentsList project={project} includeInvestmentList={true} />
        </GeneralDefaultPaper>
    )
}

export default InvestmentDetails;